import { render, staticRenderFns } from "./CustomerRankTop.vue?vue&type=template&id=7bf6c061&"
import script from "./CustomerRankTop.vue?vue&type=script&lang=js&"
export * from "./CustomerRankTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports